import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";


export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr{
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary{
    background-color: #05367f;
    display: block;
    border: 0px;
    width: 100%;
  }

  .card {
    margin: 15px 0px;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 0;
  display: block;
  margin: 0 15px;
  color: #333;

  .pull-right{
    position: relative;
    float: right;
  }
`;

export const PageHeader = styled.div`
  background: linear-gradient(135deg, #024995 0%, #009bd9 60%, #009bd9 100%);
  padding: 40px 20px;
  margin: 0;
  border-radius: 25px 25px 0 0;
  box-shadow: 0 8px 25px rgba(0, 123, 198, 0.2);
  text-align: center;
  position: relative;
  overflow: hidden;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="2" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="80" r="1.5" fill="rgba(255,255,255,0.1)"/></svg>');
    opacity: 0.3;
  }
`;

export const WelcomeTitle = styled.h1`
  color: #fff;
  font-size: 28px;
  font-weight: 300;
  margin: 0 0 10px 0;
  position: relative;
  z-index: 1;
`;

export const UserName = styled.h2`
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const StatsCard = styled.div`
  background: #fff;
  border-radius: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
  overflow: hidden;
  position: relative;
  margin: 20px 15px;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: #009bd9;
  }

  .card-header {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 1px solid #dee2e6;
    padding: 15px 20px;
    font-weight: 600;
    font-size: 14px;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .card-body {
    padding: 25px 20px;
    text-align: center;
  }

  .card-title {
    font-size: 24px;
    font-weight: 700;
    color: #009bd9;
    margin-bottom: 10px;
  }

  .card-text {
    color: #6c757d;
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const FormCard = styled.div`
  background: #fff;
  border-radius: 25px;
  box-shadow: none;
  padding: 40px;
  margin: 30px 15px 0 15px;
  position: relative;
  overflow: hidden;
  width: calc(100% - 30px);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: #009bd9;
  }
`;

export const FormTitle = styled.h2`
  color: #495057;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 3px;
    background: #009bd9;
    border-radius: 2px;
  }
`;

export const StyledFormGroup = styled.div`
  margin-bottom: 25px;
  
  label {
    color: #495057;
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  input {
    border: 2px solid #e9ecef;
    border-radius: 8px;
    padding: 12px 15px;
    font-size: 14px;
    transition: all 0.3s ease;
    
    &:focus {
      border-color: #009bd9;
      box-shadow: 0 0 0 3px rgba(0, 155, 217, 0.1);
      outline: none;
    }
  }
  
  hr {
    border: none;
    height: 1px;
    background: linear-gradient(90deg, transparent, #dee2e6, transparent);
    margin: 20px 0;
  }
`;

export const StyledButton = styled.button`
  background: linear-gradient(135deg, #024995 0%, #009bd9 60%, #009bd9 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(2, 73, 149, 0.3);
  width: 100%;
  margin-top: 20px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(2, 73, 149, 0.4);
    background: #009bd9;
    color: white;
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const InfoText = styled.p`
  color: #6c757d;
  font-size: 13px;
  line-height: 1.5;
  margin: 20px 0;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #009bd9;
`;

export const ErrorMessage = styled.p`
  color: #28a745;
  font-weight: 600;
  margin-top: 15px;
  padding: 10px;
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 8px;
  text-align: center;
`;

export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;



/* ---------------------------------------------------------------------------
   Cabeçalho do card de dados cadastrais: título de um lado, ação de senha do
   outro. A troca de senha saiu do formulário e virou modal próprio.
   --------------------------------------------------------------------------- */

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 26px;
`;

export const BotaoSenha = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: #fff;
  border: 1.5px solid #c5e0f7;
  color: #024995;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.18s ease;
  white-space: nowrap;

  i {
    font-size: 13px;
    color: #009bd9;
  }

  &:hover {
    background: #eef6fd;
    border-color: #009bd9;
  }
`;

/* Modal de troca de senha, com o mesmo enquadramento dos demais da plataforma. */
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 30, 55, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1050;
`;

export const Dialogo = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 440px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(2, 73, 149, 0.3);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
`;

export const DialogoTopo = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 20px 24px;
  border-bottom: 1px solid #eef2f7;

  .icone {
    width: 40px;
    height: 40px;
    border-radius: 11px;
    background: linear-gradient(135deg, #024995 0%, #009bd9 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      color: #fff;
      font-size: 16px;
    }
  }

  h3 {
    margin: 0 0 2px;
    font-size: 17px;
    font-weight: 800;
    color: #1a2740;
  }

  p {
    margin: 0;
    font-size: 12.5px;
    color: #8698ab;
  }
`;

export const DialogoCorpo = styled.div`
  padding: 22px 24px;
`;

export const CampoSenha = styled.div`
  & + & {
    margin-top: 14px;
  }

  label {
    display: block;
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #8698ab;
    margin-bottom: 6px;
  }

  .entrada {
    position: relative;
  }

  input {
    width: 100%;
    border: 1.5px solid ${(p) => (p.$erro ? "#dc3545" : "#e8eef5")};
    border-radius: 10px;
    padding: 11px 42px 11px 13px;
    font-size: 14px;
    background: ${(p) => (p.$erro ? "#fffafa" : "#f7fafd")};
    color: #1a2740;
    outline: none;
    box-sizing: border-box;
    font-family: inherit;

    &:focus {
      border-color: ${(p) => (p.$erro ? "#dc3545" : "#009bd9")};
      background: #fff;
      box-shadow: 0 0 0 3px
        ${(p) => (p.$erro ? "rgba(220,53,69,0.12)" : "rgba(0,155,217,0.12)")};
    }
  }

  /* Aqui o olho funciona: é página, não email. */
  .olho {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 7px 9px;
    cursor: pointer;
    color: #8698ab;
    font-size: 14px;
    line-height: 1;

    &:hover {
      color: #024995;
    }
  }

  .erro {
    display: block;
    font-size: 11.5px;
    color: #a12727;
    font-weight: 600;
    margin-top: 5px;
  }
`;

export const RegraSenha = styled.p`
  margin: 12px 0 0;
  font-size: 12px;
  line-height: 1.55;
  color: #8698ab;
`;

export const DialogoAcoes = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #eef2f7;
  background: #fafcfe;

  @media (max-width: 520px) {
    flex-direction: column-reverse;
  }
`;

const acaoBase = `
  border-radius: 9px;
  padding: 10px 18px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  border: 1.5px solid transparent;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const BotaoCancelar = styled.button`
  ${acaoBase}
  background: #fff;
  border-color: #e8eef5;
  color: #7a8fa6;

  &:hover:not(:disabled) {
    border-color: #009bd9;
    color: #024995;
  }
`;

export const BotaoConfirmar = styled.button`
  ${acaoBase}
  background: linear-gradient(135deg, #024995 0%, #009bd9 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(2, 73, 149, 0.28);

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
`;


/*
  Erro do modal de senha. Existe separado porque o `ErrorMessage` acima é verde —
  na versão antiga a mesma caixa servia para sucesso e para erro.
*/
export const ErroSenha = styled.p`
  margin: 12px 0 0;
  padding: 10px 14px;
  background: #fdecec;
  border: 1px solid #f5c2c2;
  border-radius: 8px;
  color: #a12727;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
`;


/*
  Dados cadastrais em modo leitura. A edição virou modal, igual à troca de senha:
  além de deixar as duas ações no mesmo padrão, evita alteração acidental do
  e-mail — que é o identificador de login.
*/
export const ListaDados = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 28px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export const ItemDado = styled.div`
  min-width: 0;

  dt {
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    color: #8698ab;
    margin: 0 0 4px;
  }

  dd {
    margin: 0;
    font-size: 15.5px;
    font-weight: 600;
    color: #1a2740;
    overflow-wrap: anywhere;
  }

  .vazio {
    color: #b3c1d1;
    font-weight: 500;
  }
`;

export const AcoesCabecalho = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

/* Variante em destaque do botão do cabeçalho, para a ação principal do card. */
export const BotaoEditar = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: linear-gradient(135deg, #024995 0%, #009bd9 100%);
  border: 1.5px solid transparent;
  color: #fff;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.18s ease;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(2, 73, 149, 0.26);

  i {
    font-size: 13px;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;


/* Valor com botão de revelar ao lado (usado no CPF). */
export const ValorComOlho = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .valor {
    font-size: 15.5px;
    font-weight: 600;
    color: #1a2740;
    /* Largura estável: alternar oculto/visível não pode mexer no layout. */
    font-variant-numeric: tabular-nums;
  }

  button {
    background: none;
    border: none;
    padding: 2px 4px;
    cursor: pointer;
    color: #8698ab;
    font-size: 13px;
    line-height: 1;

    &:hover {
      color: #024995;
    }
  }
`;


/* Requisitos da senha em linha, acendendo conforme são atendidos. */
export const Requisitos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
`;

export const Requisito = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: ${(p) => (p.$ok ? "#eafaf1" : "#f4f6f9")};
  border: 1px solid ${(p) => (p.$ok ? "#b7e4c7" : "#e3e8ee")};
  color: ${(p) => (p.$ok ? "#1b7a4b" : "#8698ab")};
  transition: all 0.18s ease;

  i {
    font-size: 9px;
  }
`;

/* Aviso de conferência da confirmação, logo abaixo do campo. */
export const Conferencia = styled.p`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 6px 0 0;
  font-size: 11.5px;
  font-weight: 600;
  color: ${(p) => (p.$ok ? "#1b7a4b" : "#a12727")};

  i {
    font-size: 10px;
  }
`;
